export const NAME = 'statsTeamSelect';

export const ALL_TEAMS = {
  label: 'All teams',
  value: 'all',
};
